var _style, _g, _g2, _defs, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlutenIntolerance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B82455;}\n\t.st1{fill:#ECB880;}\n\t.st2{fill:#E4A056;}\n\t.st3{fill:#FFE8B6;}\n\t.st4{clip-path:url(#SVGID_2_);fill:none;stroke:#FDFFFF;stroke-width:6.0201;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152,88.1c0-11.4-11.1-20.7-25.1-21.2v-0.1H86.8v0.1c-13.9,0.5-25.1,9.8-25.1,21.2c0,4.7,1.9,9,5,12.5V132 c0,5.5,4.5,10,10,10l0,0h60.1c5.5,0,10-4.5,10-10l0,0v-31.4C150.1,97.1,152,92.8,152,88.1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.4,
    y: 100.6,
    className: "st2",
    width: 37.6,
    height: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.4,88.1c0-8.7-8.9-15.8-20-16.3c-0.4,0-5.8,0-6.3,0c-11.8,0-21.3,7.3-21.3,16.3c0,4,1.9,7.7,5,10.5v30.9 c0,4.2,3.4,7.5,7.5,7.5l0,0h22.6c4.2,0,7.5-3.4,7.5-7.5l0,0V98.6C112.5,95.8,114.4,92.1,114.4,88.1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M106.3,183.2c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.7,148.7,63.5,183.2,106.3,183.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 42.8,
    y1: 43,
    x2: 176.6,
    y2: 164.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlutenIntolerance);
export default __webpack_public_path__ + "static/media/Gluten_Intolerance.3da48712bab17ec2b74fae6acd684c8f.svg";
export { ForwardRef as ReactComponent };